declare module "@mui/material/styles" {
    interface TypographyVariants {
        h1Medium: React.CSSProperties;
        h1SemiBold: React.CSSProperties;
        h1Bold: React.CSSProperties;
        h2Medium: React.CSSProperties;
        h2SemiBold: React.CSSProperties;
        h2Bold: React.CSSProperties;
        h3Medium: React.CSSProperties;
        h3SemiBold: React.CSSProperties;
        h3Bold: React.CSSProperties;
        subtitle: React.CSSProperties;
        subtitleMedium: React.CSSProperties;
        subtitleSemiBold: React.CSSProperties;
        subtitleBold: React.CSSProperties;
        cta: React.CSSProperties;
        ctaMedium: React.CSSProperties;
        ctaSemiBold: React.CSSProperties;
        ctaBold: React.CSSProperties;
        body: React.CSSProperties;
        bodyMedium: React.CSSProperties;
        bodySemiBold: React.CSSProperties;
        bodyBold: React.CSSProperties;
        caption: React.CSSProperties;
        captionMedium: React.CSSProperties;
        captionSemiBold: React.CSSProperties;
        captionBold: React.CSSProperties;
    }

    interface TypographyVariantsOptions {
        h1Medium?: React.CSSProperties;
        h1SemiBold?: React.CSSProperties;
        h1Bold?: React.CSSProperties;
        h2Medium?: React.CSSProperties;
        h2SemiBold?: React.CSSProperties;
        h2Bold?: React.CSSProperties;
        h3Medium?: React.CSSProperties;
        h3SemiBold?: React.CSSProperties;
        h3Bold?: React.CSSProperties;
        subtitle?: React.CSSProperties;
        subtitleMedium?: React.CSSProperties;
        subtitleSemiBold?: React.CSSProperties;
        subtitleBold?: React.CSSProperties;
        cta?: React.CSSProperties;
        ctaMedium?: React.CSSProperties;
        ctaSemiBold?: React.CSSProperties;
        ctaBold?: React.CSSProperties;
        body?: React.CSSProperties;
        bodyMedium?: React.CSSProperties;
        bodySemiBold?: React.CSSProperties;
        bodyBold?: React.CSSProperties;
        caption?: React.CSSProperties;
        captionMedium?: React.CSSProperties;
        captionSemiBold?: React.CSSProperties;
        captionBold?: React.CSSProperties;
    }
}

declare module "@mui/material/Typography" {
    interface TypographyPropsVariantOverrides {
        h1Medium: true;
        h1SemiBold: true;
        h1Bold: true;
        h2Medium: true;
        h2SemiBold: true;
        h2Bold: true;
        h3Medium: true;
        h3SemiBold: true;
        h3Bold: true;
        subtitle: true;
        subtitleMedium: true;
        subtitleSemiBold: true;
        subtitleBold: true;
        cta: true;
        ctaMedium: true;
        ctaSemiBold: true;
        ctaBold: true;
        body: true;
        bodyMedium: true;
        bodySemiBold: true;
        bodyBold: true;
        caption: true;
        captionMedium: true;
        captionSemiBold: true;
        captionBold: true;
        subtitle1: false;
        subtitle2: false;
        body1: false;
        body2: false;
        overline: false;
    }
}

export default {
    h1: {
        fontWeight: 400,
        fontSize: 33,
        lineHeight: 1.4,
    },
    h1Medium: {
        fontWeight: 500,
        fontSize: 33,
        lineHeight: 1.4,
    },
    h1SemiBold: {
        fontWeight: 600,
        fontSize: 33,
        lineHeight: 1.4,
    },
    h1Bold: {
        fontWeight: 700,
        fontSize: 33,
        lineHeight: 1.4,
    },
    h2: {
        fontWeight: 500,
        fontSize: 23,
        lineHeight: 1.4,
    },
    h2Medium: {
        fontWeight: 500,
        fontSize: 23,
        lineHeight: 1.4,
    },
    h2SemiBold: {
        fontWeight: 600,
        fontSize: 23,
        lineHeight: 1.4,
    },
    h2Bold: {
        fontWeight: 700,
        fontSize: 23,
        lineHeight: 1.4,
    },
    h3: {
        fontWeight: 500,
        fontSize: 20,
        lineHeight: 1.4,
    },
    h3Medium: {
        fontWeight: 500,
        fontSize: 20,
        lineHeight: 1.4,
    },
    h3SemiBold: {
        fontWeight: 600,
        fontSize: 20,
        lineHeight: 1.4,
    },
    h3Bold: {
        fontWeight: 700,
        fontSize: 20,
        lineHeight: 1.4,
    },
    subtitle: {
        fontWeight: 400,
        fontSize: 16,
        lineHeight: 1.4,
    },
    subtitleMedium: {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: 1.4,
    },
    subtitleSemiBold: {
        fontWeight: 600,
        fontSize: 16,
        lineHeight: 1.4,
    },
    subtitleBold: {
        fontWeight: 700,
        fontSize: 16,
        lineHeight: 1.4,
    },
    cta: {
        fontWeight: 400,
        fontSize: 14,
        lineHeight: 1.4,
    },
    ctaMedium: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: 1.4,
    },
    ctaSemiBold: {
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 1.4,
    },
    ctaBold: {
        fontWeight: 700,
        fontSize: 14,
        lineHeight: 1.4,
    },
    body: {
        fontWeight: 400,
        fontSize: 13,
        lineHeight: 1.4,
    },
    bodyMedium: {
        fontWeight: 500,
        fontSize: 13,
        lineHeight: 1.4,
    },
    bodySemiBold: {
        fontWeight: 600,
        fontSize: 13,
        lineHeight: 1.4,
    },
    bodyBold: {
        fontWeight: 700,
        fontSize: 13,
        lineHeight: 1.4,
    },
    caption: {
        fontWeight: 400,
        fontSize: 11,
        lineHeight: 1.4,
    },
    captionMedium: {
        fontWeight: 500,
        fontSize: 11,
        lineHeight: 1.4,
    },
    captionSemiBold: {
        fontWeight: 600,
        fontSize: 11,
        lineHeight: 1.4,
    },
    captionBold: {
        fontWeight: 700,
        fontSize: 11,
        lineHeight: 1.4,
    },
    // Disable default MUI variants
    subtitle1: undefined,
    h4: undefined,
    h5: undefined,
    h6: undefined,
    subtitle2: undefined,
    body1: undefined,
    body2: undefined,
    overline: undefined,
};
